import type { VideoProps } from 'types/videoTypes';
import { formatSecondsToMinutes } from 'utils/time';
import { getVideoDuration } from 'utils/videoPlayer';
import styles from './Creditbox.module.scss';

interface Props {
  video: VideoProps;
}

export const CreditBox = ({ video }: Props) => {
  const videoDuration = getVideoDuration(video);
  const timeLabel = formatSecondsToMinutes(videoDuration, 'min');

  return (
    <div className={styles.box}>
      {videoDuration && videoDuration > 0 && <div className={styles.time}>{timeLabel}</div>}
      <div className={styles.subtitle}>{video.fields.subtitle}</div>
      <div className={styles.title}>{video.fields.title}</div>
    </div>
  );
};
